"use client";

import { c as _c } from "react/compiler-runtime";
import SpinnerLoader from "@/components/common/SpinnerLoader";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { NotificationDisplayItem } from "@/types/feed.types";
import type { ReactNode } from "react";
import MyStreamNoItems from "../../my-stream/layout/MyStreamNoItems";
import NotificationsWrapper from "../NotificationsWrapper";
import NotificationsStateMessage from "./NotificationsStateMessage";
interface NotificationsContentProps {
  readonly isLoadingProfile: boolean;
  readonly hasConnectedProfile: boolean;
  readonly hasProfileHandle: boolean;
  readonly showProxyDisabledState: boolean;
  readonly showErrorState: boolean;
  readonly resolvedErrorMessage: string;
  readonly handleRetry: () => void;
  readonly handleAuthRetry: () => void;
  readonly handleProxyDisable: () => void;
  readonly showLoader: boolean;
  readonly showNoItems: boolean;
  readonly items: NotificationDisplayItem[];
  readonly loadingOlder: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly setActiveDrop: (activeDrop: ActiveDropState | null) => void;
  readonly markNotificationIdsAsRead?: (ids: number[]) => Promise<void>;
}
export default function NotificationsContent(t0) {
  const $ = _c(22);
  const {
    isLoadingProfile,
    hasConnectedProfile,
    hasProfileHandle,
    showProxyDisabledState,
    showErrorState,
    resolvedErrorMessage,
    handleRetry,
    handleAuthRetry,
    handleProxyDisable,
    showLoader,
    showNoItems,
    items,
    loadingOlder,
    activeDrop,
    setActiveDrop,
    markNotificationIdsAsRead
  } = t0;
  if (isLoadingProfile) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-flex tw-min-h-full tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-py-8"><SpinnerLoader text="Loading profile..." /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!hasConnectedProfile) {
    let t1;
    if ($[1] !== handleAuthRetry) {
      t1 = <NotificationsStateMessage message="Connect your wallet to view notifications." action={{
        label: "Reconnect wallet",
        handler: handleAuthRetry
      }} />;
      $[1] = handleAuthRetry;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (!hasProfileHandle) {
    let t1;
    if ($[3] !== handleAuthRetry) {
      t1 = <NotificationsStateMessage message="We couldn't determine your profile handle. Please reconnect to continue." action={{
        label: "Reconnect wallet",
        handler: handleAuthRetry
      }} />;
      $[3] = handleAuthRetry;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (showProxyDisabledState) {
    let t1;
    if ($[5] !== handleProxyDisable) {
      t1 = <NotificationsStateMessage message="Notifications are not available while you are using a profile proxy." action={{
        label: "Switch to primary profile",
        handler: handleProxyDisable
      }} />;
      $[5] = handleProxyDisable;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  if (showErrorState) {
    let t1;
    if ($[7] !== handleRetry) {
      t1 = {
        label: "Try again",
        handler: handleRetry
      };
      $[7] = handleRetry;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    let t2;
    if ($[9] !== resolvedErrorMessage || $[10] !== t1) {
      t2 = <NotificationsStateMessage message={resolvedErrorMessage} action={t1} />;
      $[9] = resolvedErrorMessage;
      $[10] = t1;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    return t2;
  }
  if (showLoader) {
    let t1;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-flex tw-min-h-full tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-py-8"><SpinnerLoader text="Loading notifications..." /></div>;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    return t1;
  }
  if (showNoItems) {
    let t1;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-flex tw-min-h-full tw-flex-1 tw-flex-col tw-items-center tw-justify-start"><MyStreamNoItems /></div>;
      $[13] = t1;
    } else {
      t1 = $[13];
    }
    return t1;
  }
  let t1;
  if ($[14] !== markNotificationIdsAsRead) {
    t1 = markNotificationIdsAsRead !== undefined && {
      markNotificationIdsAsRead
    };
    $[14] = markNotificationIdsAsRead;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== activeDrop || $[17] !== items || $[18] !== loadingOlder || $[19] !== setActiveDrop || $[20] !== t1) {
    t2 = <NotificationsWrapper items={items} loadingOlder={loadingOlder} activeDrop={activeDrop} setActiveDrop={setActiveDrop} {...t1} />;
    $[16] = activeDrop;
    $[17] = items;
    $[18] = loadingOlder;
    $[19] = setActiveDrop;
    $[20] = t1;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  return t2;
}